/**
 *
 * Asynchronously loads the component for Men001
 * Author: TruongTx
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
